import React, { createContext, useContext, useState, ReactNode } from "react";

interface HeaderContextType {
  visible: boolean;
  showHeader: () => void;
  hideHeader: () => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(true);

  const showHeader = () => setVisible(true);
  const hideHeader = () => setVisible(false);

  return (
    <HeaderContext.Provider value={{ visible, showHeader, hideHeader }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (!context) throw new Error("useHeader must be used inside HeaderProvider");
  return context;
};